export const FIRST_USER_ID = "fromBomUserId";
export const SECOND_USER_ID = "userId";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const COMMUNITY_ID = "communityId";
export const BOM_POSITION_ID = "bomPositionId";
